import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { logShopifyConfig } from './config/shopify'

// Log Shopify configuration in development mode
if (import.meta.env.DEV) {
  logShopifyConfig();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
